import React from 'react'

import type {
  FilterComponentProps,
  FilterPresetOption,
} from 'types/filter-page'

import { useKeyPress } from 'hooks/use-key-press'

import { FilterOperatorSelector } from '../../filter-operator-selector'
import { getMissingValuePresets } from '../../utils'

// A boolean field has nothing to type, so every option is a preset: the two
// values on `equals`, then the missing-value pair on `exists`.
const BOOLEAN_VALUE_PRESETS: FilterPresetOption[] = [
  { id: 'is_true', label: 'is true', operator: 'equals', value: 'true' },
  { id: 'is_false', label: 'is false', operator: 'equals', value: 'false' },
]

const BooleanForm = ({
  label,
  value,
  onChange,
  operator = 'equals',
  onPress,
}: FilterComponentProps) => {
  const { handleKeyDown } = useKeyPress('Enter', onPress)

  const presets = [...BOOLEAN_VALUE_PRESETS, ...getMissingValuePresets(label)]

  return (
    <FilterOperatorSelector
      operator={operator}
      value={value}
      presets={presets}
      onChange={onChange}
      onKeyDown={handleKeyDown}
    />
  )
}

export default BooleanForm
